import React, { memo } from 'react'
import PropTypes from 'prop-types'

const VARIANTS = ['primary', 'positive', 'negative', 'hidden', 'secondary']
const SIZES = ['md', 'sm', 'tiny']

function ActionButton(props) {
  const {
    children,
    className,
    disabled,
    handleOnClick,
    onBlur,
    onFocus,
    onMouseEnter,
    onMouseLeave,
    variant,
    size
  } = props

  return (
    <button
      className={`action-button action-button--${variant} ${className} ${
        size ? `action-button--${size}` : ''
      }`}
      disabled={disabled}
      onBlur={onBlur}
      onClick={handleOnClick}
      onFocus={onFocus}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      type="button"
    >
      <div className="action-button__text">{children}</div>
    </button>
  )
}

ActionButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  handleOnClick: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  size: PropTypes.oneOf(SIZES),
  variant: PropTypes.oneOf(VARIANTS)
}

ActionButton.defaultProps = {
  className: '',
  disabled: false,
  onBlur: undefined,
  onFocus: undefined,
  onMouseEnter: undefined,
  onMouseLeave: undefined,
  size: SIZES[0],
  variant: 'primary'
}

export default memo(ActionButton)
